import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'
import { useToasts } from './useToasts'
import type { ScheduleView } from '../types/device'

export function useSchedules(deviceId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['schedules', deviceId],
    queryFn: () => api.getSchedules(deviceId!),
    enabled: enabled && !!deviceId,
  })
}

export function useSaveSchedules() {
  const qc = useQueryClient()
  const { push } = useToasts()
  return useMutation({
    mutationFn: ({ id, schedule }: { id: string; schedule: ScheduleView }) => api.saveSchedules(id, schedule),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: ['schedules', vars.id] })
      push('success', 'Programmazione salvata')
    },
    onError: (e) => push('error', (e as Error)?.message || 'Errore salvataggio'),
  })
}
